// src/config/intervalOptions.js
// Migrated verbatim from prototype/between-the-lines-v2.html lines 1868-1876.

export const INTERVAL_OPTIONS = [
    { value: 'monthly', label: 'Monthly',     suffix: '/mo',   description: '1 month of access' },
    { value: '3m',      label: '3 Months',    suffix: '/3mo',  description: '3 months of access' },
    { value: '6m',      label: '6 Months',    suffix: '/6mo',  description: '6 months of access' },
    { value: 'yearly',  label: 'Yearly',      suffix: '/yr',   description: '12 months of access' }
];

// Current purchase backend grants 12 months regardless of the legacy
// autoRenewInterval field. Do not advertise a billing schedule it cannot create.
export const getIntervalLabel = () => '12-month access';
export const getIntervalSuffix = () => '';
export const getIntervalDescription = () => '12 months of access · No automatic renewal';
